import * as corePixiInit from './core/initializePixi.js'
const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      console.error(`Error using gameUI.${func}():`, error)
      throw error
    })

const resetPixiGame = loadAndExecuteFunction('resetPixiGame')

export const pixiAppResize = (x, y) => {
  corePixiInit.resizePixiApp(x, y)
  resetPixiGame(x, y)
}


export const bingoPixiApplicationInit = (setIsPixiAssetsLoaded) => corePixiInit.init(setIsPixiAssetsLoaded)

export const bingoPixiAssetsLoad = (setIsPixiAssetsLoaded) => corePixiInit.loadPixiAssets(setIsPixiAssetsLoaded)

export const bingoPixiApplicationDestroy = () => corePixiInit.destroyPixiApp()

export const isSimulate = true


export const animateBingoBall = loadAndExecuteFunction('animateBingo')
export const setBingoAnimationVisiblity = loadAndExecuteFunction('setVisiblity')